@if (menuItem?.id === 'MARKETING' || menuItem?.id === 'INBOX' || menuItem?.id === 'TRIAGE') {
    <span class="m-menu__link-badge">
        @if (value > 0) {
            <span class="m-badge m-badge--danger">{{ value }}</span>
        }
    </span>
}

@if (menuItem?.id === 'HELLO_DOCTOR') {
    <asn-hd-status></asn-hd-status>
}

@if (menuItem?.id === 'TELEPHONY') {
    <asn-telephony-status></asn-telephony-status>
}
